import { SET_SELECTED_ANNOUNCEMENT, SET_LANDLORD_ANNOUNCEMENTS, SET_ANNOUNCEMENT_STATE, SET_ANNOUNCEMENT_LOAD_STATE, SET_INTEREST_REQUEST_STATE, CLEAR_LANDLORD_DATA, SET_ANNOUNCEMENT_LISTENER } from "../actions/landlordActions";
import { requestState } from "../actions/utils";

const initialState = {
    selectedAnnouncement: undefined,
    announcements: [],
    announcementState: requestState.none,
    announcementLoadState: requestState.none,
    interestRequestState: requestState.none,
    onAnnouncementSelection: undefined
}

export default function landlordReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_SELECTED_ANNOUNCEMENT:
            return {
                ...state,
                selectedAnnouncement: action.id
            }
        case SET_LANDLORD_ANNOUNCEMENTS:
            return {
                ...state,
                announcements: action.announcements
            }
        case SET_ANNOUNCEMENT_LOAD_STATE:
            return {
                ...state,
                announcementLoadState: action.state
            }
        case SET_ANNOUNCEMENT_STATE:
            return {
                ...state,
                announcementState: action.state
            }
        case SET_INTEREST_REQUEST_STATE:
            return {
                ...state,
                interestRequestState: action.state
            }
        case SET_ANNOUNCEMENT_LISTENER:
            return {
                ...state,
                onAnnouncementSelection: action.listener
            }
        case CLEAR_LANDLORD_DATA:
            return {
                ...initialState
            }
        default: return state;
    }
}